"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _AngleLeft["default"];
  }
});

var _AngleLeft = _interopRequireDefault(require("../lib/icons/legacy/AngleLeft"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
